import React from 'react';
import ContactForm from '../components/ContactForm';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import SEO from '../components/SEO';

const Contact = () => {
  return (
    <div className="min-h-screen" data-testid="contact-page">
      <SEO 
        title="Kontaktai | WSK Logistika – logistikos centras Kaune"
        description="Susisiekite su WSK Logistika. Sandėliavimo ir logistikos paslaugos Kaune. Nemajūnų g. 19, tel. +370 650 17855, info@wsklogistika.lt."
        keywords="kontaktai WSK Logistika, logistikos centras Kaunas, sandėliavimo paslaugos, Nemajūnų g. 19"
      />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Kontaktai</h1>
            <p className="text-xl text-blue-100">
              Susisiekite su mumis ir gaukite individualų pasiūlymą jūsų verslui
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information and Form */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Susisiekite su mumis</h2>
              
              <div className="space-y-6 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg">
                    <MapPin className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Adresas</h3>
                    <p className="text-gray-600">Nemajūnų g. 19</p>
                    <p className="text-gray-600">LT-52459 Kaunas</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg">
                    <Phone className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Telefonas</h3>
                    <a href="tel:+37065017855" className="text-blue-600 hover:underline">
                      +370 650 17855
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg">
                    <Mail className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">El. paštas</h3>
                    <a href="mailto:info@wsklogistika.lt" className="text-blue-600 hover:underline">
                      info@wsklogistika.lt
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 bg-blue-100 p-3 rounded-lg">
                    <Clock className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Darbo laikas</h3>
                    <p className="text-gray-600">Pirmadienis – Penktadienis</p>
                    <p className="text-gray-600">9:00 – 15:00</p>
                  </div>
                </div>
              </div>

              {/* Company Info */}
              <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
                <h3 className="font-semibold text-gray-900 mb-3">Įmonės informacija</h3>
                <p className="text-gray-600 mb-2">MB „WSK Logistikos paslaugos"</p>
                <p className="text-gray-600">Direktorė: Violeta Venclovienė</p>
              </div>

              {/* Map placeholder */}
              <div className="mt-8 h-64 bg-gray-200 rounded-xl overflow-hidden">
                <iframe
                  title="WSK Logistika location"
                  src="https://www.google.com/maps?q=Nemaj%C5%ABn%C5%B3%20g.%2019%2C%20LT-52459%20Kaunas&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Užpildykite užklausos formą</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
